export var DATABASE_SCHEMA_VERSION = 2;
export var DEFAULT_VIEW_KEY = 'default';
export default {
  DEFAULT_VIEW_KEY: DEFAULT_VIEW_KEY,
  DATABASE_SCHEMA_VERSION: DATABASE_SCHEMA_VERSION
};